import React, { useEffect, useState } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import { useNavigate, useParams } from "react-router-dom";
import { BiCopy, BiLock } from "react-icons/bi";
import { FaPhp, FaCheck } from "react-icons/fa";

const NewDeployment = () => {
    const { t } = useLanguage();
    const { project_id } = useParams();
    const navigate = useNavigate();
    const [err, setErr] = useState({ message: "", display: false });
    const user_id = sessionStorage.getItem("user_id");

    const [copiedIndex, setCopiedIndex] = useState(null); // track which step was copied

    const goBack = () => {
        navigate(`/project_panel/${project_id}/deployments`);
    };

    const handleCopy = async (text, index) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopiedIndex(index);
            setTimeout(() => setCopiedIndex(null), 2000); // reset after 2s
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    const steps = [
        { title: "1. Install the Erioon CLI", command: "pip install erioon", description: "Install the Erioon CLI globally so you can manage deployments directly from your terminal. After installation, ensure the CLI is available in your PATH. For example, on Windows you may need to add: export PATH=$PATH:/c/Users/<YourUser>/AppData/Roaming/Python/Python312/Scripts. Replace <YourUser> with your actual username." },
        { title: "2. Log in", command: "erioon login", description: "Authenticate using your access credentials or API key. This links the CLI to your Erioon account." },
        { title: "3. Initialize Erioon in your project", command: "erioon init", description: "Run this inside your project folder. It will set up configuration files so Erioon can track deployments, logs, and metrics." },
    ];

    return (
        <div>
            <div className="new_section_main_view">
                <p className="new_section_main_view_title">
                    <i className="fa-solid fa-chevron-left" onClick={goBack}></i> New deployment
                </p>
                <p className="new_section_main_view_subtitle">
                    Complete the steps below to deploy your project.
                </p>

                <div className="deployments_container fade-in">
                    {steps.map((step, index) => (
                        <div className="instruction_step_card" key={index}>
                            <p className="db_title">{step.title}</p>
                            {step.command && (
                                <div className="command_container">
                                    <pre>{step.command}</pre>
                                    <i
                                        onClick={() => handleCopy(step.command, index)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        {copiedIndex === index ? (
                                            <FaCheck color="green" className="fade-in"/>
                                        ) : (
                                            <BiCopy className="fade-in"/>
                                        )}
                                    </i>
                                </div>
                            )}
                            <p className="deployment_description">{step.description}</p>
                        </div>
                    ))}

                    <div className="instruction_step_card">
                        <p className="db_title">4. Select your project</p>
                        <p className="deployment_description">
                            Pick the project you want to deploy. This ensures all deployments and logs are tied to the right workspace inside Erioon.
                        </p>
                    </div>

                    <div className="instruction_step_card">
                        <p className="db_title">5. Name your deployment</p>
                        <p className="deployment_description">
                            Give your deployment a unique, descriptive name. This makes it easier to find and manage later.
                        </p>
                    </div>

                    <div className="instruction_step_card">
                        <p className="db_title">6. Choose a deployment type</p>
                        <p className="deployment_description">
                            Decide what you’re deploying — a service, AI model, ML training job, or something else. Each type is optimized for different use cases.
                        </p>
                    </div>

                    <div className="instruction_step_card">
                        <p className="db_title">7. Done!</p>
                        <p className="deployment_description">
                            That’s it — your app is ready to deploy with Erioon. 🎉
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewDeployment;
